import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "../_keys";
import { Routes } from "../_routes";

import { urlMaker } from "utils";

export const updateCorp = async ({ id, name, status }: UpdateCorpReqT) =>
  axios.put(urlMaker(Routes.UPDATE_CORP, id), { name, status });

export const useUpdateCorp = () =>
  useMutation({
    mutationKey: [Keys.UPDATE_CORP],
    mutationFn: updateCorp,
    cacheTime: Infinity,
  });
